import React from "react";
import { COLORS } from "../colors"; // تأكد من مسار الاستيراد الصحيح

const DallaSupport = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: COLORS.background,
        color: COLORS.text,
        padding: "20px",
      }}
    >
      <header
        style={{
          backgroundColor: COLORS.primary,
          color: COLORS.light,
          padding: "20px",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "2em", fontWeight: "bold" }}>دعم الدلة</h1>
      </header>

      <main
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: COLORS.light,
          borderRadius: "10px",
          padding: "20px",
          marginTop: "20px",
        }}
      >
        <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
          كيف يمكننا مساعدتك؟
        </h2>
        <p>
          مرحبًا بك في صفحة الدعم الخاصة بتطبيق <strong>الدلة</strong>. إذا كان
          لديك أي استفسارات أو مشكلات، نحن هنا لمساعدتك.
        </p>

        <h3 style={{ fontSize: "1.2em", marginTop: "20px" }}>
          الأسئلة الشائعة
        </h3>
        <ul>
          <li>
            <strong>سؤال:</strong> كيف أبدأ اللعب؟
            <br />
            <strong>إجابة:</strong> افتح التطبيق واختر المستوى الذي ترغب في
            لعبه، ثم ابدأ بتخمين الكلمات.
          </li>
          {/* أضف المزيد من الأسئلة الشائعة حسب الحاجة */}
        </ul>

        <h3 style={{ fontSize: "1.2em", marginTop: "20px" }}>اتصل بنا</h3>
        <p>
          إذا كنت بحاجة إلى مزيد من المساعدة، يرجى التواصل معنا عبر البريد
          الإلكتروني:{" "}
          <a href="mailto:tarbaa.kw@gmail.com" style={{ color: COLORS.accent }}>
            tarbaa.kw@gmail.com
          </a>
        </p>
      </main>

      <footer
        style={{
          backgroundColor: COLORS.primary,
          color: COLORS.light,
          textAlign: "center",
          padding: "20px",
          marginTop: "20px",
        }}
      >
        <p>© 2025 الدلة. جميع الحقوق محفوظة.</p>
      </footer>
    </div>
  );
};

export default DallaSupport;
